import { useCallback } from "react";
import { useSetRecoilState } from "recoil";
import { broadcastStateUpdated } from "state/messageState";
import { Broadcast } from "types/signalR";
import { Message } from "hooks/useSnackbarMessage";

const useSystemMessageReceived = (setSnackbarValues: (message: Message | undefined) => void) => {
  const updateBroadcast = useSetRecoilState(broadcastStateUpdated);

  const callback = useCallback(
    (message: Broadcast | undefined) => {
      if (!message) return;

      updateBroadcast((n: number) => n + 1);
      setSnackbarValues({ message: `Du har ett nytt systemmeddelande`, type: "info" });
    },
    [updateBroadcast, setSnackbarValues]
  );

  return callback;
};

export default useSystemMessageReceived;
